(function () {
  'use strict';

  var modal;
  var contextInput;
  var quantityInput;
  var messageInput;
  var pageInput;
  var previousFocus;

  function text(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function currentProductDetails(trigger) {
    var productTitle = text(trigger.dataset.fisQuoteProduct);
    var titleElement = document.querySelector('.product-detail__title');
    var variantSelect = document.querySelector('select[data-product-select]');
    var quantity = document.querySelector('.product-detail input[name="quantity"]');
    var details = [];

    if (!productTitle && titleElement) productTitle = text(titleElement.textContent);
    if (productTitle) details.push(productTitle);

    if (variantSelect && variantSelect.options.length) {
      var selectedVariant = text(variantSelect.options[variantSelect.selectedIndex].textContent);
      if (selectedVariant && selectedVariant.toLowerCase() !== 'default title') details.push(selectedVariant);
    }

    return {
      context: details.join(' — '),
      quantity: quantity ? quantity.value : ''
    };
  }

  function currentCartDetails(trigger) {
    var summary = text(trigger.dataset.fisCartSummary);
    var total = 0;
    var items = [];

    document.querySelectorAll('.cart-item-container').forEach(function (row) {
      var input = row.querySelector('.quantity__number');
      var itemQuantity = input ? (Number(input.value) || 0) : 0;
      var itemTitle = row.querySelector('.description__title');
      var variants = Array.prototype.map.call(row.querySelectorAll('.description__variant'), function (variant) {
        return text(variant.textContent);
      }).filter(Boolean);

      total += itemQuantity;
      if (itemTitle) {
        items.push((itemQuantity || 1) + 'x ' + text(itemTitle.textContent) + (variants.length ? ' — ' + variants.join(', ') : ''));
      }
    });

    return {
      context: summary || items.join(' | ') || 'Producten uit de winkelwagen',
      quantity: total || ''
    };
  }

  function requestDetails(trigger) {
    var source = text(trigger.dataset.fisQuoteContext);
    var product = text(trigger.dataset.fisQuoteProduct);
    var result;

    if (trigger.dataset.fisCartSummary !== undefined || source === 'Winkelwagen' || document.body.classList.contains('template-cart')) {
      result = currentCartDetails(trigger);
    } else if (product || document.body.classList.contains('template-product')) {
      result = currentProductDetails(trigger);
    } else {
      var pageTitle = document.querySelector('main h1');
      result = {
        context: source || (pageTitle ? text(pageTitle.textContent) : text(document.title)),
        quantity: ''
      };
    }

    if (!result.context) result.context = source || 'Algemene B2B-aanvraag';
    return result;
  }

  function fillForm(trigger) {
    var details = requestDetails(trigger);
    var autoMessage = 'Ik ontvang graag een B2B-offerte voor ' + details.context + '. ' +
      'Ik hoor graag wat er mogelijk is met kleuren, maten en borduring of bedrukking.';

    if (contextInput) contextInput.value = details.context;
    if (quantityInput && details.quantity) quantityInput.value = details.quantity;
    if (pageInput) pageInput.value = window.location.href;

    if (messageInput && (!messageInput.value.trim() || messageInput.value === messageInput.dataset.fisAutoValue)) {
      messageInput.value = autoMessage;
      messageInput.dataset.fisAutoValue = autoMessage;
    }
  }

  function focusableElements() {
    if (!modal) return [];
    return Array.prototype.slice.call(modal.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return element.offsetParent !== null;
    });
  }

  function openModal(trigger, skipFill) {
    if (!modal) return;
    previousFocus = document.activeElement;
    if (!skipFill && trigger) fillForm(trigger);

    modal.hidden = false;
    document.documentElement.classList.add('fis-quote-is-open');
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var success = modal.querySelector('[data-fis-quote-success]');
      var focusTarget = success ||
        modal.querySelector('.fis-quote-modal__form input:not([type="hidden"]), .fis-quote-modal__form textarea') ||
        modal.querySelector('[data-fis-quote-close]');
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    });

    var mobileMenu = trigger && trigger.closest('.fis-mobile-menu');
    if (mobileMenu) mobileMenu.removeAttribute('open');
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('fis-quote-is-open');
    window.setTimeout(function () {
      modal.hidden = true;
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    }, 260);
  }

  function onKeydown(event) {
    if (!modal || modal.hidden) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;
    var focusable = focusableElements();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function init() {
    modal = document.querySelector('[data-fis-quote-modal]');
    if (!modal) return;

    contextInput = modal.querySelector('[data-fis-quote-context-input]');
    quantityInput = modal.querySelector('[data-fis-quote-quantity]');
    messageInput = modal.querySelector('[data-fis-quote-message]');
    pageInput = modal.querySelector('[data-fis-quote-page]');

    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-fis-quote-open]');
      var closer = event.target.closest('[data-fis-quote-close]');

      if (opener) {
        event.preventDefault();
        openModal(opener, false);
      } else if (closer) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', onKeydown);

    var openOnLoad = modal.querySelector('[data-fis-quote-open-on-load]');
    var params = new URLSearchParams(window.location.search);
    if (openOnLoad || params.get('fis_quote_sent') === '1' || window.location.hash === '#FisQuoteModal') {
      openModal(null, true);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
